import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {
    AnnotationClipboardData,
    isAnnotationClipboardData,
} from '../model/annotation-clipboard-data';

@Injectable({
    providedIn: 'root',
})
export class KeyEventsService {
    $modalOpen: Subject<boolean> = new Subject();

    triggerModalStatus(isOpen: boolean) {
        this.$modalOpen.next(isOpen);
    }

    /**
     * Copies annotation data to clipboard as JSON string
     */
    async copyAnnotationToClipboard(
        data: AnnotationClipboardData
    ): Promise<void> {
        try {
            await navigator.clipboard.writeText(JSON.stringify(data));
        } catch (err) {
            console.error('Failed to copy annotation:', err);
        }
    }

    /**
     * Reads annotation data from clipboard and checks if it is of type AnnotationClipboardData
     */
    async readAnnotationFromClipboard(): Promise<AnnotationClipboardData | null> {
        try {
            const text = await navigator.clipboard.readText();
            const parsed = JSON.parse(text);
            if (isAnnotationClipboardData(parsed)) {
                return parsed;
            }
            return null;
        } catch (err) {
            console.error(
                'Failed to read or parse annotation from clipboard:',
                err
            );
            return null;
        }
    }
}
